/* eslint-disable*/

import { Container, Grid, Typography, Box } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { currentchannel } from 'feactures/channel/channelSlice';
import {
  ownAmazonCategoryShareGraph,
  ownRakutenCategoryShareGraph,
  ownYahooCategoryShareGraph
} from 'feactures/brand/categoryBrandShareSlice';
import CategorySharegraph from 'components/molecules/dashboard/CategorySharegraph';

const OwnBrandItemShare = () => {
  // 実際のデータはuseEffectで取得しreduxへ
  const categoryShareAmazonGraphData = useSelector(ownAmazonCategoryShareGraph);
  const categoryShareRakutenGraphData = useSelector(
    ownRakutenCategoryShareGraph
  );
  const categoryShareYahooGraphData = useSelector(ownYahooCategoryShareGraph);
  const channel = useSelector(currentchannel);

  let categoryShareGraphData = {
    sales: [],
    percentage: [],
    label: [],
    cumulative_percentages: []
  };

  if (channel == 1) {
    categoryShareGraphData = categoryShareAmazonGraphData.graphdata;
  } else if (channel == 2) {
    categoryShareGraphData = categoryShareRakutenGraphData.graphdata;
  } else if (channel == 3) {
    categoryShareGraphData = categoryShareYahooGraphData.graphdata;
  }

  const sales = categoryShareGraphData.sales;
  const count = sales.filter((item) => item >= 1).length;
  const hasOneOrMore = count >= 1;

  return (
    <>
      <Container maxWidth={false}>
        <Grid container rowSpacing={0.3} columnSpacing={1.5} height={364.9}>
          <>
            <Grid item xs={12} mb={1}>
              <Typography fontSize="14px" fontWeight="bold">
                自社店舗：商品別売上シェア
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {hasOneOrMore ? (
                <>
                  {/* 円グラフ */}
                  <CategorySharegraph
                    graphdata={categoryShareGraphData}
                    labelLayout="legend"
                  />
                </>
              ) : (
                <Box display="flex" justifyContent="center">
                  <Typography fontSize={15}>
                    表示できるデータがありません
                  </Typography>
                </Box>
              )}
            </Grid>
          </>
        </Grid>
      </Container>
    </>
  );
};

export default OwnBrandItemShare;
